"use strict";
// @ts-ignore
try {
    self['workbox:cacheable-response:7.3.0'] && _();
}
catch (e) { }
